<template>
  <section class="section section-white" id="faq">
    <div class="container text-center fade-in-section">
      <h2 class="section-title">Frequently Asked Questions</h2>
      <p class="section-subtitle max-w-3xl">Everything you need to know about TestHiveQA.</p>
      
      <div class="faq-grid">
        <div class="faq-item">
          <h3 class="faq-question">When will TestHiveQA launch?</h3>
          <p class="faq-answer">We're planning to launch in Q1 2026. Waitlist members will get early access before public launch.</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">Do I need QA experience to use it?</h3>
          <p class="faq-answer">Not at all! We have scenarios for complete beginners to seasoned professionals. Start where you are.</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">How are badges verified?</h3>
          <p class="faq-answer">Each badge is tied to actual completed work on our platform. Employers can verify any badge with a single click.</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">Can I use this while employed?</h3>
          <p class="faq-answer">Absolutely! Many users build their portfolio to strengthen their position or prepare for new opportunities.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FAQSection'
}
</script>
